import fp from 'lodash/fp';

export const syncCpdCategoryWithGoals = (details, setGoals, systemProfile) => {
  const { cpdCategorys, goals } = details;
  const { cpdCategoryGoals } = systemProfile;
  const selectedCpdCategories = fp.flow(
    fp.filter(({ points }) => points > 0),
    fp.map('cpdCategoryId')
  )(cpdCategorys);

  const goalsShouldSelect = fp.flow(
    fp.filter(({ cpdCategoryId }) => {
      return fp.includes(cpdCategoryId)(selectedCpdCategories);
    }),
    fp.map('progressGoalId'),
    fp.uniq
  )(cpdCategoryGoals);

  const updatedGoals = fp.flow(fp.concat(goalsShouldSelect), fp.uniq)(goals);
  if (!fp.equals(goals)(updatedGoals)) {
    setGoals(updatedGoals);
  }
};



// WEBPACK FOOTER //
// ./src/containers/pages/shared/syncCpdCategoryWithGoals.js